"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var React = require("react");
var services_1 = require("@falcon/services");
var Tree_1 = require("../../components/Tree");
var ValuableItemTree = /** @class */ (function (_super) {
    __extends(ValuableItemTree, _super);
    function ValuableItemTree(props) {
        return _super.call(this, props) || this;
    }
    ValuableItemTree.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(Tree_1.Tree, { label: "Specified items and bicycles", children: [this.props.interaction.valuableItems && this.props.interaction.valuableItems.length > 0 &&
                    (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Specified items", children: this.renderItems(this.props.interaction.valuableItems) }), this.props.interaction.valuableItems && this.props.interaction.valuableItems.length === 0 &&
                    (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Specified items [0]" }), this.props.interaction.bicycles && this.props.interaction.bicycles.length > 0 &&
                    (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Bicycles", children: this.renderItems(this.props.interaction.bicycles) }), this.props.interaction.bicycles && this.props.interaction.bicycles.length === 0 &&
                    (0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Bicycles [0]" })] }));
    };
    ValuableItemTree.prototype.renderItems = function (items) {
        var itemArray = [];
        if (items && items.length > 0) {
            itemArray = items.map(function (item) {
                return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [item.description, " - ", item.coverLocation === services_1.ValuableItemCoverLocation.HOME ?
                                "Covered in home" : "Covered away from home", " - ", services_1.CommonHelpers.getAmountToDisplay(item.value)] }) }, item.valuableItemId));
            });
        }
        return itemArray;
    };
    ValuableItemTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], ValuableItemTree);
    return ValuableItemTree;
}(React.Component));
exports.default = ValuableItemTree;
//# sourceMappingURL=ValuableItemTree.js.map